<app-preloader></app-preloader>
<app-navbar *ngIf="showNav"></app-navbar>
    <router-outlet></router-outlet>
<app-footer *ngIf="showNav"></app-footer>
<app-popup-modal-component></app-popup-modal-component> 